import { Form, FormRenderProps } from 'react-final-form';
import { Stack, Button } from '@mui/material';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { LinkItem } from '@occc/ui-design-system';

import { DefaultScreenForm } from '../../components/default-screen-form/default-screen-form.component';
import { DefaultScreenFormValues } from '../../touchpoint.types';
import { validate } from '../../utils/default-screen-form.validation';
import {
  CANCEL_BUTTON_TEXT,
  SAVE_BUTTON_TEXT,
  DEFAULT_SCREENS_PAGE_SUBTITLE,
  DEFAULT_SCREENS_CREATE_PAGE_TITLE,
} from '../../touchpoint.constants';

const initialValues: Partial<DefaultScreenFormValues> = {
  name: '',
  description: '',
  landscapeImage: null,
  squareImage: null,
  portraitImage: null,
  landscapeImageUrl: null,
  squareImageUrl: null,
  portraitImageUrl: null,
  kioskIds: [],
};

type DefaultScreensCreatePageProps = {
  breadcrumbLinks: LinkItem[];
  onSubmit: (values: DefaultScreenFormValues) => Promise<void>;
  onCancel: () => void;
  isSubmitting: boolean;
};

export const DefaultScreensCreatePage = ({
  breadcrumbLinks,
  onSubmit,
  onCancel,
  isSubmitting,
}: DefaultScreensCreatePageProps) => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  const renderForm = ({
    handleSubmit,
    valid,
    submitting,
  }: FormRenderProps<DefaultScreenFormValues>) => {
    const isDisabled = submitting || isSubmitting || !valid;

    return (
      <Page
        browserTabTitle={DEFAULT_SCREENS_CREATE_PAGE_TITLE}
        pageHeaderProps={{
          title: DEFAULT_SCREENS_CREATE_PAGE_TITLE,
          subtitle: DEFAULT_SCREENS_PAGE_SUBTITLE,
        }}
        actions={
          <Stack direction='row' spacing={1}>
            <Button variant='outlined' color='secondary' onClick={onCancel}>
              {CANCEL_BUTTON_TEXT}
            </Button>
            <Button
              variant='contained'
              color='secondary'
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              {SAVE_BUTTON_TEXT}
            </Button>
          </Stack>
        }
      >
        <DefaultScreenForm isEditMode={false} handleSubmit={handleSubmit} />
      </Page>
    );
  };

  return (
    <Form<DefaultScreenFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      validate={validate}
      initialValues={initialValues}
    />
  );
};
